import {AuthorizationsOdontoItem} from 'domain/usecases/private/authorizations-odonto/get-authorizations-odonto';
import {translations} from 'presentation/translations-new';
import IconNamesType from 'presentation/icons/IconNamesType';
import {formatText} from 'presentation/utils';
import {OdontoStatus, AuthorizationOdontoStatusEnum} from '../constants';

const {authorizationCard, passwordSection} =
	translations['pt-br'].privateFlow.requestAuthorizations;

export const getOdontoStatusList = (
	authorization: AuthorizationsOdontoItem,
	status: OdontoStatus,
) => {
	if (status === AuthorizationOdontoStatusEnum.FINISHED) {
		return [
			{
				iconName: 'event-filled' as IconNamesType,
				primaryText: authorization.dtSolicitacaoAutorizacao
					? authorization.dtSolicitacaoAutorizacao
					: '-',
				secondaryText: authorizationCard.requestedAt,
				flexDirection: 'column-reverse',
			},
			{
				iconName: 'assignment-filled' as IconNamesType,
				primaryText: authorization.protocolo ? authorization.protocolo : '-',
				secondaryText: authorizationCard.protocol,
				flexDirection: 'column-reverse',
			},
			{
				iconName: 'assignment-lnd-filled' as IconNamesType,
				primaryText: formatText(authorization?.nmPrestador),
				flexDirection: 'column-reverse',
			},
		];
	}

	if (
		status === AuthorizationOdontoStatusEnum.UNDER_ANALYSIS ||
		status === AuthorizationOdontoStatusEnum.PENDING
	) {
		return [
			{
				iconName: 'assignment-lnd-filled' as IconNamesType,
				primaryText: formatText(authorization?.nmPrestador),
				flexDirection: 'column-reverse',
			},
			{
				iconName: 'event-filled' as IconNamesType,
				primaryText: `${passwordSection.validate} ${authorization?.dtValidadeAutorizacao}`,
				flexDirection: 'column-reverse',
			},
		];
	}

	if (status === AuthorizationOdontoStatusEnum.REJECTED) {
		return [
			{
				iconName: 'event-filled' as IconNamesType,
				primaryText: authorization.dtSolicitacaoAutorizacao
					? authorization.dtSolicitacaoAutorizacao
					: '-',
				secondaryText: authorizationCard.requestedAt,
				flexDirection: 'column-reverse',
			},
			{
				iconName: 'assignment-filled' as IconNamesType,
				primaryText: authorization.protocolo ? authorization.protocolo : '-',
				secondaryText: authorizationCard.protocol,
				flexDirection: 'column-reverse',
			},
		];
	}

	if (status === AuthorizationOdontoStatusEnum.CANCELED) {
		return [
			{
				iconName: 'assignment-lnd-filled' as IconNamesType,
				primaryText: formatText(authorization?.nmPrestador),
				flexDirection: 'column-reverse',
			},
		];
	}

	return [];
};
